import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import * as loginActions from './loginActions';
import { catchError, map, tap, exhaustMap, switchMap } from "rxjs/operators";
import { LoginService } from '../../services/login/login.service';
import { Router, ActivatedRoute } from '@angular/router';
import { of } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { Login } from '../../modules/login/login';
import { Countries } from '../../modules/login/countries';
import { environment } from '../../../../environments/environment';
import { AllGames } from '../../modules/slotsmodel/allgames';
import { AllGameLunch } from '../../modules/slotsmodel/allgamelunch';
import { SlotsService } from '../../services/slotsservice/slots.service';
import { GamesService } from '../../services/games/games.service';

const handleError = (error: any, actions: any) => {
    if (error.error instanceof Error) {
        return of(new actions({ "message": error.error.message }));
    } else {
        try {
            if (error.error.message) {
                return of(new actions({ "message": error.error.message }));
            } else if (error.message) {
                return of(new actions({ "message": error.message }));
            }
            return of(new actions({ "message": "something went wrong please contact admin" }));
        } catch (error) { }
    }
    return of(new actions({ "message": "something went wrong please contact admin" }));
};

@Injectable()
export class LoginEffects {

    constructor(
        private actions$: Actions,
        private loginservice: LoginService,
        private slotsService: SlotsService,
        private gamesService: GamesService,
        private router: Router,
        private route: ActivatedRoute
    ) { }

    loginStart$ = createEffect(() => this.actions$.pipe(
        ofType(loginActions.LOGIN_START),
        exhaustMap((onLoginStart: loginActions.LoginStart) =>
            this.loginservice.onLogin(onLoginStart.payload).pipe(
                map((response: Login) => new loginActions.LoginSuccess(response)),
                catchError((error: HttpErrorResponse) => handleError(error, loginActions.LoginFail))
            )
        )
    ));

    loginSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(loginActions.LOGIN_SUCCESS),
        tap((onLoginSuccess: loginActions.LoginSuccess) => {
            console.log(onLoginSuccess.payload.success)
            console.log(onLoginSuccess)
            if (onLoginSuccess.payload.success === true) {
                const sessionId: any = onLoginSuccess.payload.sessionId;
                if (sessionId) {
                    sessionStorage.setItem('wsessionBD', sessionId);
                    this.slotsService.walletupdate().subscribe();
                    this.loginservice.onPlayerLoggedIn(true);
                    this.router.navigate(['/home']);
                    window.scroll(0, 0);
                 
                } else {
                    this.loginservice.onPlayerLoggedIn(false);
                    this.router.navigate(['/home']);

                }
            } else {
               
                this.loginservice.onPlayerLoggedIn(false);
            }
        })
    ), { dispatch: false });

    loginFail$ = createEffect(() => this.actions$.pipe(
        ofType(loginActions.LOGIN_FAIL),
        tap((onLoginFailed: loginActions.LoginFail) => {
        })
    ), { dispatch: false });



    registerStart$ = createEffect(() => this.actions$.pipe(
        ofType(loginActions.REGISTER_START),
        exhaustMap((onRegisterStart: loginActions.RegisterStart) =>
            this.loginservice.onRegister(onRegisterStart.payload).pipe(
                map((response: Login) => new loginActions.RegisterSuccess(response)),
                catchError((error: HttpErrorResponse) => handleError(error, loginActions.RegisterFail))
            )
        )
    ));

    registerSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(loginActions.REGISTER_SUCCESS),
        tap((onRegisterSuccess: loginActions.RegisterSuccess) => {
            console.log(onRegisterSuccess);
            if (onRegisterSuccess.payload.success === true) {
                console.log(onRegisterSuccess?.payload?.loginResponse)
                if(onRegisterSuccess?.payload?.description){

                }else{
                    sessionStorage.setItem('wsessionBD', onRegisterSuccess?.payload?.loginResponse?.sessionId);
                    sessionStorage.setItem('register_su', onRegisterSuccess?.payload?.loginResponse?.affiliatePostBackURL);
                    this.loginservice.onPlayerLoggedIn(true);

                }
                this.router.navigate(['/home']);
                window.scroll(0, 0);
                return;
            }
            this.loginservice.onPlayerLoggedIn(false);
        })
    ), { dispatch: false });

    registerGetCountry$ = createEffect(() => this.actions$.pipe(
        ofType(loginActions.REGISTER_GET_COUNTRY),
        exhaustMap((onRegisterGetCountry: loginActions.RegisterGetCountry) =>
            this.loginservice.onGetRegisterCountry().pipe(
                map((response: Countries) => new loginActions.RegisterGetCountrySuccess(response)),
                catchError((error: HttpErrorResponse) => handleError(error, loginActions.RegisterGetCountryFail))
            )
        )
    ));

    logoutStart$ = createEffect(() => this.actions$.pipe(
        ofType(loginActions.LOGOUT_START),
        exhaustMap((onLogOutStart: loginActions.LoginStart) =>
            this.loginservice.onLogOut().pipe(
                map((response: Login) => {
                    this.loginservice.onPlayerLoggedIn(false);

                    window.location.reload();
                    return new loginActions.LogoutSuccess(response);
                }),
                catchError((error: HttpErrorResponse) => handleError(error, loginActions.LogoutFail))
            )
        )
    ));

    logoutSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(loginActions.LOGOUT_SUCCESS),
        tap((onLogOutSuccess: loginActions.LogoutSuccess) => {
            const success = (onLogOutSuccess.payload as { success: boolean }).success;
            // this.router.navigate(['/home']);
            sessionStorage.removeItem('wsessionBD');
            sessionStorage.removeItem('profile');
            this.loginservice.onPlayerLoggedIn(false);
            if (success === true) {
                this.router.navigate(['/home']);
                sessionStorage.removeItem('wsessionBD');
                sessionStorage.removeItem('profile');
                this.loginservice.onPlayerLoggedIn(false);
            }
        })
    ), { dispatch: false });

    logoutFail$ = createEffect(() => this.actions$.pipe(
        ofType(loginActions.LOGOUT_FAIL),
        tap((onLogOutFailed: loginActions.LogoutFail) => {
            sessionStorage.removeItem('wsessionBD');
            sessionStorage.removeItem('profile');
            this.loginservice.onPlayerLoggedIn(false);
        })
    ), { dispatch: false });

    forgotPasswordStart$ = createEffect(() => this.actions$.pipe(
        ofType(loginActions.FORGOTPASSWORD_START),
        exhaustMap((onForgotPasswordStart: loginActions.ForgotPasswordStart) =>
            this.loginservice.onForgotPassword(onForgotPasswordStart.payload).pipe(
                map(response => new loginActions.ForgotPasswordSuccess(response)),
                catchError((error: HttpErrorResponse) => handleError(error, loginActions.ForgotPasswordFail))
            )
        )
    ));

    forGotPasswordSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(loginActions.FORGOTPASSWORD_SUCCESS),
        tap((onForgotPasswordSuccess: loginActions.ForgotPasswordSuccess) => {
            const success = (onForgotPasswordSuccess.payload as { success: boolean }).success;
            if (success === true) {
            }
        })
    ), { dispatch: false });

    registerGenarateOTP$ = createEffect(() => this.actions$.pipe(
        ofType(loginActions.REGISTER_GENERATE_OTP),
        exhaustMap((onRegisterGenarateOTPStart: loginActions.RegisterGenarateOTP) =>
            this.loginservice.onRegisterGenarateOTPStart(onRegisterGenarateOTPStart.payload).pipe(
                map(response => new loginActions.RegisterGenarateOTPSuccess(response)),
                catchError((error: HttpErrorResponse) => handleError(error, loginActions.RegisterGenarateOTPFail))
            )
        )
    ));

    allGamesStart$ = createEffect(() => this.actions$.pipe(
        ofType(loginActions.ALL_GAMES_START),
        exhaustMap((onAllGamesStart: loginActions.allGamesStart) =>
            this.loginservice.AllGamesData().pipe(
                map((response: AllGames) => new loginActions.allGamesSuccess(response)),
                catchError((error: HttpErrorResponse) => handleError(error, loginActions.allGamesFail))
            )
        )
    ));

    allGamesLunchStart$ = createEffect(() => this.actions$.pipe(
        ofType(loginActions.ALL_GAMES_LUNCH_START),
        exhaustMap((onAllGamesLunchStart: loginActions.allGamesLunchStart) =>
            this.loginservice.AllGamesLunch(onAllGamesLunchStart.payload).pipe(
                map((response: AllGameLunch) => new loginActions.allGamesLunchSuccess(response)),
                catchError((error: HttpErrorResponse) => handleError(error, loginActions.allGamesLunchFail))
            )
        )
    ));
}
